import { IRequestResult } from "../schemas/structure"

interface IMembershipStats {
    active: number
    closed: number
}

interface IInvestmentStats {
    balance: number
    monthBalance: number
    contributionBalance: number
    savings: number
    withdrawals: number
    monthCount: number
}

interface IStatsService {
    membership(): angular.IPromise<IRequestResult<IMembershipStats>>
    investments(): angular.IPromise<IRequestResult<IInvestmentStats>>
}

class StatsService implements IStatsService {

    static $inject = ["$q", "$http", "BASEAPI"];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string) { }

    membership() {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/stats/members`).then((response: IRequestResult<IMembershipStats>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    investments() {
        let defer = this.$q.defer()
        this.$http.get(`${this.baseUrl}/stats/investments`).then((response: IRequestResult<IInvestmentStats>) => {
            defer.resolve(response)
        })
        return defer.promise
    }


}

export { StatsService, IStatsService }


// WEBPACK FOOTER //
// ./app/main/stats_service.ts